import {
    Autocomplete as MuiAutocomplete,
    TextField as MuiTextField,
} from "@mui/material"
import { styled } from "@mui/material/styles"

const SMALL_SIZE = 24
const DEFAULT_SIZE = 32

export const TextField = styled(MuiTextField, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ small, theme }) => ({
    width: small ? 150 : 200,
    "& MuiAutoComplete-input": {
        height: small ? SMALL_SIZE : DEFAULT_SIZE,
        "& input + fieldset": {
            borderColor: theme["primary"],
        },
    },
}))

const height = 24

export const TextFieldInputStyle = {
    borderRadius: 16,
    fontSize: "13px",
    height,
    padding: "0px 28px 0px 14px",
}
export const TextFieldInputLabelStyle = {
    height,
}

export const Autocomplete = styled(MuiAutocomplete)({
    alignSelf: "center",
})
